import { createSlice } from "@reduxjs/toolkit";

const conditionSlice = createSlice({
    name: "conditions",
    initialState: {},
    reducers: {
        registerCondition: (state, action) => {
            const condition = action.payload;

            if (!condition?.id) return;

            // Only add if not already present
            if (!state[condition.id]) {
                state[condition.id] = condition;
            } else {
                console.warn(
                    `⚠️ Condition ${condition.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterConditions: (state, action) => {
            action.payload.forEach((condition) => {
                if (!condition?.id) return;

                if (!state[condition.id]) {
                    state[condition.id] = condition;
                } else {
                    console.warn(
                        `⚠️ Condition ${condition.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerCondition,
    bulkRegisterConditions
} = conditionSlice.actions;

export default conditionSlice.reducer;
